import { render, staticRenderFns } from "./UserImg.vue?vue&type=template&id=0cdfb214&scoped=true&"
import script from "./UserImg.vue?vue&type=script&lang=ts&"
export * from "./UserImg.vue?vue&type=script&lang=ts&"
import style0 from "./UserImg.vue?vue&type=style&index=0&id=0cdfb214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfb214",
  null
  
)

export default component.exports